import { Outlet } from 'react-router-dom';
import { useAutoPageTracking } from '../hooks/useAutoPageTracking';
import { MainNavbar } from './MainNavbar';
import { Footer } from './Footer';
import { useLocation } from 'react-router-dom';
import GlobalSearch from '../component/Search/GlobalSearch';
import { AdBanner } from '../pages/AdBanner';

export const TrackedLayout = () => {
    const location = useLocation();
    const { pageViewCount, isTracked, routeName, masterPageId, childPageId } = useAutoPageTracking();

    const hideAd = ["/login", "/ForgotPassword"]
        .includes(location.pathname);

    return (
        <div className="app-container">
            <MainNavbar />
            <div className="bg-white border-bottom shadow-sm">
                <div className="container-fluid px-3 py-2">
                    <div className="row align-items-center g-2">

                        {/* Left — Ad banner */}
                        {!hideAd && (
                            <div className="col-12 col-lg-5">
                                <AdBanner />
                            </div>
                        )}

                        {/* Right — Search box */}
                        <div className="col-12 col-lg-7">
                            <GlobalSearch />
                        </div>

                    </div>
                </div>
            </div>
            <main id="main-content">
                {/* Pass all tracking info to child components */}
                <Outlet context={{
                    pageViewCount,
                    isTracked,
                    routeName,
                    masterPageId,
                    childPageId
                }} />
            </main>
            <Footer />
        </div>
    );
};